<template>
  <div class="power">
    <h2>软件著作权</h2>
    <p></p>
    <div class="power-swiper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="slide-item">
              <img
                :src="item.image"
                v-for="(item, index) in powerList"
                :key="index"
                v-show="index<4"
              />
            </div>
          </div>

          <div class="swiper-slide" v-if="powerList.length>4">
            <div class="slide-item">
              <img
                :src="item.image"
                v-for="(item, index) in powerList"
                :key="index"
                v-show="4 <= index && index < 8"
              />
            </div>
          </div>
         
          <div class="swiper-slide" v-if="powerList.length>8">
            <div class="slide-item">
              <img
                :src="item.image"
                v-for="(item, index) in powerList"
                :key="index"
                v-show="8 <= index && index < 16"
              />
            </div>
          </div>
          <div class="swiper-slide" v-if="powerList.length>8">
            <div class="slide-item">
              <img
                :src="item.image"
                v-for="(item, index) in powerList"
                :key="index"
                v-show="14 <= index && index < 20"
              />
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  props: {
    powerList: Array,
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      let listLenght = this.powerList.lenght;
      for (let i = 0; i < listLenght; i++) {
      this.list.push({ num: i });
      }
    })
  },
  methods: {
    imgSwiper() {
      this.$nextTick(() => {
      this.swiper = new Swiper(".power-swiper .swiper-container", {
        pagination: {
          el: ".swiper-pagination",
        },
      });
    })
    },
  },
  watch: {
    powerList(newVal) {
      let that=this;
      let listLength = Math.ceil(newVal.length/4);
      for (let i = 0; i < listLength; i++) {
        that.list.push({ num: i+1 });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.power-swiper {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}

.swiper-wrapper {
  margin: 0 auto;
  height: 100%;
}

.swiper-container {
  width: 80%;
}

.swiper-slide {
  padding: 0 40px;

  .slide-item {
    display: flex;
    align-items: center;

    img {
      margin-left: 40px;
    }
  }

  img {
    display: flex;
    width: 280px;
    height: 385px;
    align-items: center;
    margin-bottom: 24px;
    margin-left: 18%;
  }
}

>>>.swiper-pagination {
  left: 0;
  top: 390px;
  width: 100%;
}

>>>.swiper-pagination-bullet {
  width: 16px;
  height: 6px;
  display: inline-block;
  background: #666666;
  opacity: 0.3;
  margin: 0 5px;
  border-radius: 3px;
}

>>>.swiper-pagination-bullet-active {
  width: 40px;
  opacity: 1;
  background-color: $yellow;
}

.power {
  position: relative;
  padding-top: 79px;
  text-align: center;
  overflow: hidden;
  padding-bottom: 115px;
  max-width: 1920px;
  min-width: 1440px;
  margin: 0 auto;
  background: #F5F5F5;

  h2 {
    text-align: center;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    letter-spacing: 2px;
  }

  >p:first-of-type {
    border-bottom: 1px solid #F5BA1A;
    margin: 24px auto 0;
    width: 42px;
    height: 2px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/AboutPower.vue